module.exports = __webpack_public_path__ + "img/flags/CW.cb93a9a.png";